import { render } from "./TabsLangs.vue?vue&type=template&id=40e2f0ba&scoped=true"
import script from "./TabsLangs.vue?vue&type=script&lang=js"
export * from "./TabsLangs.vue?vue&type=script&lang=js"

import "./TabsLangs.vue?vue&type=style&index=0&id=40e2f0ba&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e2f0ba"]])

export default __exports__